<template>
    <div class="about">
        <div class="top">
			<img src="../assets/images/about-top.png" alt="">
			<div class="width nav-box">
				<img src="../assets/images/logo-index.png" class="logo" alt="" srcset="">
				<div class="nav">
					<p>首页</p>
					<p>业务介绍</p>
					<p>产品中心</p>
					<p>
						<el-dropdown trigger="click" :popper-append-to-body="false">
							<span class="el-dropdown-link">
								新闻动态
								<!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>公司新闻</el-dropdown-item>
								<el-dropdown-item >业务动态</el-dropdown-item>
								<el-dropdown-item>击树突破</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</p>
					<!-- <p style="color:#4CA3FF">新闻动态</p> -->
					<!-- <p>招聘信息</p> -->
					<p>关于我们</p>
				</div>
			</div>
		</div>
		<div class="width title-box">
			<!-- <img src="../assets/images/about-title.png" alt="" srcset=""> -->
			<p class="title">公司新闻</p>
			<!-- <div class="tips-box">
				<img src="../assets/images/icon-right.png" alt="" srcset="">
				<p>业务动态</p>
			</div> -->
		</div>
		<div class="width timeline-box">
			<div class="time-box">
				<p>2020</p>
				<p class="active">2020</p>
				<p>2020</p>
				<p>2020</p>
				
			</div>
			<div class="right">
				<div class="flex-between">
					<div class="left-line">
						<img src="../assets/images/line-time.png" alt="">
						<p class="bg-line"></p>
					</div>
					<div class="con-right">
						<p class="icon-box">
							<span class="icon"></span>
						</p>
						2019年11月，面对声像数据和影像资料收集不畅、考核不严、查阅不便、管理费劲等众多情况，杭州市公安局数字声像资源管理系统项目组成立，以公安内网为依托，引入“互联网+大数据管理”理念，实现“市级、区（县）级、部门级、民警级”四个层级的收集、整理、保管、利用、服务五大环节管理，统一建立全市共享、共用的声像数据库。为全市突发事件响应和为民众服务共享数据提供支撑，加快推进杭州“独特韵味别样精彩”世界名城建设。
					</div>
				</div>
				<div class="flex-between">
					<div class="left-line">
						<img src="../assets/images/line-time.png" alt="">
						<p class="bg-line"></p>
					</div>
					<div class="con-right">
						<p class="icon-box">
							<span class="icon"></span>
						</p>
						2019年11月，面对声像数据和影像资料收。
					</div>
				</div>
				<div class="flex-between">
					<div class="left-line">
						<img src="../assets/images/line-time.png" alt="">
						<p class="bg-line"></p>
					</div>
					<div class="con-right">
						<p class="icon-box">
							<span class="icon"></span>
						</p>
						2019年11月，面对声像数据和影像资料收集不畅、考核不严、查阅不便、管理费劲等众多情况，杭州市公安局数字声像资源管理系统项目组成立，以公安内网为依托，引入“互联网+大数据管理”理念，实现“市级、区（县）级、部门级、民警级”四个层级的收集、整理、保管、利用、服务五大环节管理，统一建立全市共享、共用的声像数据库。为全市突发事件响应和为民众服务共享数据提供支撑，加快推进杭州“独特韵味别样精彩”世界名城建设。
					</div>
				</div>
				<div class="flex-between">
					<div class="left-line">
						<img src="../assets/images/line-time.png" alt="">
						<p class="bg-line"></p>
					</div>
					<div class="con-right">
						<p class="icon-box">
							<span class="icon"></span>
						</p>
						2019年11月，面对声像数据和影像资料收。
					</div>
				</div>
				<!-- <el-timeline>
					<el-timeline-item timestamp="2018/4/12" hide-timestamp color='#0091FF'>
					<el-card>
						<p class="card-con">2019年11月，面对声像数据和影像资料收集不畅、考核不严、查阅不便、管理费劲等众多情况，杭州市公安局数字声像资源管理系统项目组成立，以公安内网为依托，引入“互联网+大数据管理”理念，实现“市级、区（县）级、部门级、民警级”四个层级的收集、整理、保管、利用、服务五大环节管理，统一建立全市共享、共用的声像数据库。为全市突发事件响应和为民众服务共享数据提供支撑，加快推进杭州“独特韵味别样精彩”世界名城建设。</p>
					</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2018/4/3" hide-timestamp>
					<el-card>
						<p class="card-con">2019年11月，面对声像数据和影像资料收集不畅、考核不严、查阅不便、管理费劲等众多情况，杭州市公安局数字声像资源管理系统项目组成立，以公安内网为依托，引入“互联网+大数据管理”理念，实现“市级、区（县）级、部门级、民警级”四个层级的收集、整理、保管、利用、服务五大环节管理，统一建立全市共享、共用的声像数据库。为全市突发事件响应和为民众服务共享数据提供支撑，加快推进杭州“独特韵味别样精彩”世界名城建设。</p>
					</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2018/4/2" hide-timestamp>
						<el-card>
							<p class="card-con">2019年11月，面对声像数据和影像资料收集不畅、考核不严、查阅不便、管理费劲等众多情况，杭州市公安局数字声像资源管理系统项目组成立，以公安内网为依托，引入“互联网+大数据管理”理念，实现“市级、区（县）级、部门级、民警级”四个层级的收集、整理、保管、利用、服务五大环节管理，统一建立全市共享、共用的声像数据库。为全市突发事件响应和为民众服务共享数据提供支撑，加快推进杭州“独特韵味别样精彩”世界名城建设。</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2018/4/2" hide-timestamp>
						<el-card>
							<p class="card-con">2019年11月，面对声像数据和影像资料收集不畅、考核不严、查阅不便、管理费劲等众多情况，杭州市公安局数字声像资源管理系统项目组成立，以公安内网为依托，引入“互联网+大数据管理”理念，实现“市级、区（县）级、部门级、民警级”四个层级的收集、整理、保管、利用、服务五大环节管理，统一建立全市共享、共用的声像数据库。为全市突发事件响应和为民众服务共享数据提供支撑，加快推进杭州“独特韵味别样精彩”世界名城建设。</p>
						</el-card>
					</el-timeline-item>
				</el-timeline> -->
			</div>
		</div>
		<!-- <img src="" alt="" srcset=""> -->
        <footerCom></footerCom>
    </div>
</template>
<script>
import footerCom from "../components/Footer";
export default {
    name: "Index",
    components: {
        footerCom
    }
};
</script>
<style lang="less" scoped>
.about{
	.top{
		width: 100%;
		position: relative;
		.nav-box{
			position: absolute;
			top: 12px;
			left: 50%;
			transform: translateX(-50%);
			-webkit-transform: translateX(-50%);    /* for Chrome || Safari */             
			-moz-transform: translateX(-50%);       /* for Firefox */
            -ms-transform: translateX(-50%);        /* for IE */
            -o-transform: translateX(-50%);         /* for Opera */
			height: 55px;
			z-index: 2000;
			padding-left: 20px;
			// padding-right: 50px;
			.logo{
				height: 55px;
				width: 137px;
				display: block;
				float: left;
			}
			color: #CCCCCC;
			font-size: 16px;
			.nav{
				float: right;
				height: 25px;
				line-height: 25px;
				margin-top: 15px;
				cursor: pointer;
				p{
					float: left;
					padding: 0 20px;
				}
			}
		}
	}
	.title-box{
		// position: relative;
		.title{
			font-size: 36px;
			// width: 142px;
			color: #849ABD;
			margin-top: 25px;

			// position: absolute;
			// top: 50%;
			// left: 2%;
			// transform: translateY(-50%);
			// -webkit-transform: translateY(-50%);    /* for Chrome || Safari */             
			// -moz-transform: translateY(-50%);       /* for Firefox */
            // -ms-transform: translateY(-50%);        /* for IE */
            // -o-transform: translateY(-50%);         /* for Opera */
		}
		.tips-box{
			height: 18px;
			font-size: 18px;
			position: absolute;
			top: 20%;
			right: 3%;
			// transform: translateY(-20%);
			// -webkit-transform: translateY(-20%);    /* for Chrome || Safari */             
			// -moz-transform: translateY(-20%);       /* for Firefox */
            // -ms-transform: translateY(-20%);        /* for IE */
            // -o-transform: translateY(-20%);         /* for Opera */

			p{
				float: right;
				color: #596E80;
			}
			img{
				float: right;
				width: 16px;
				margin-top: 6px;
				margin-left: 4px;
			}
		}
	}
	.right{
		.flex-between{
			display: flex;
			justify-content: space-between;
		}
		.left-line{
			width: 30px;
			position: relative;
			height: auto;
			img{
				position: absolute;
				top: 24px;
				left: 0;
				width: 30px;
				height: 30px;
			}
			.bg-line{
				margin-left: 13px;
				width: 4px;
				background: #E6E6E6;
				height: 100%;
				
				
			}
		}
		.con-right{
			margin: 10px 0;
			width: calc(100% - 50px);
			color: #666;
			font-size: 16px;
			border: 1px solid #E6E6E6;
			box-shadow: 0px 3px 5px 0px rgba(1, 0, 68, 0.2);
			padding: 15px 35px 25px;
			position: relative;
			.icon-box{
				position: absolute;
				top: 15px;
				left: -13px;
				width: 13px;
				padding-left: 5px;
				overflow: hidden;
				height: 30px;
				padding-top: 5px;
			}
			.icon{
				display: block;
				box-shadow: 0px 3px 5px 0px rgba(1, 0, 68, 0.2);
				width: 15px;
				height: 15px;
				background: #fff;
				transform:rotate(45deg);
				-ms-transform:rotate(45deg); /* IE 9 */
				-moz-transform:rotate(45deg); /* Firefox */
				-webkit-transform:rotate(45deg); /* Safari and Chrome */
				-o-transform:rotate(45deg); /* Opera */
			}
		}

	}
	.timeline-box{
		overflow: hidden;
		padding-top: 50px;
		padding-left: 5px;
		margin-bottom: 120px;
		display: flex;
		.time-box{
			width: 20.69%;
			margin-left: 2.6%;
			// border: olive 1px solid;
			margin-right: 2.8%;
			p{
				width: 75%;
				height: 50px;
				line-height: 50px;
				text-align: center;
				background:rgba(216,225,240,1);
				color: #8A9099;
				font-size: 20px;
				margin-bottom: 10px;
				cursor: pointer;
				&.active{
					width: 100%;
					height: 60px;
					line-height: 60px;
					background: url(../assets/images/about-active.png) no-repeat center center;
					background-size: 100% 100%;
					color: #FFFFFF;
					font-weight: bold;
					font-size: 24px;
				}
			}
		}
		.right{
			width:73.91%;
			.card-con{
				color: #666666;
				font-size: 15px;
				line-height: 1.4em;
			}
		}
	}
}
@media screen and (max-width: 1650px) {
	.about .title-box .tips-box{
		font-size: 16px;
	}
	.about .title-box .tips-box img{
		width: 14px;
	}
}
@media screen and (max-width: 1450px) {
	.about .title-box .tips-box{
		font-size: 14px;
	}
	.about .title-box .tips-box img{
		width: 12px;
	}
}




/deep/.el-timeline-item__tail{
	// top: 50%;
	top: 0;
	left: 7px;
	padding-top: 10%;
	display: block !important;
}
/deep/ .el-timeline-item__node{
	top: calc(50% - 20px);
	background: url(../assets/images/line-time.png) no-repeat center center;
	background-size: 100%  100%;
	width: 18px;
	height: 18px;
	// margin-bottom: 10px;
}
</style>

<style>
.el-popper .popper__arrow::after {
  content: none;
}
.el-popper[x-placement^=bottom]{
	margin-top: 0;
	margin-right: -30px;
	/* padding: 0 20px; */

}
.el-popper[x-placement^=bottom] .popper__arrow{
	display: none;
}
.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0;
    margin:  0;
    background-color: rgba(0, 0, 0, 0.3);
    border:none;
    border-radius: 0;
    box-shadow: none;
}
.el-dropdown-menu__item{
	color: #ccc;
	width: 110px;
	text-align: center;
	background-color: rgba(0, 0, 0, 0) !important;
}
.el-dropdown-menu__item:hover{
	background-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu__item:focus{
	background-color: rgba(0, 0, 0, 0);
}
.el-dropdown{
	color: #ccc;
	font-size: 16px;
}
</style>

